﻿import axios from 'src/api/axiosConfig'
import type {ApiResponse} from 'src/types/apiTypes'
import type {MessageThread, User} from 'src/types/interfaces';
import type {CreateMessage, EducationAssetResponse} from 'src/types/webContracts';
import type {AxiosResponse} from 'axios'
import {ApiRoutes} from '../ApiRoutes'


export async function getMessages(): Promise<AxiosResponse<ApiResponse<MessageThread>>> {
  const response = await axios.get(ApiRoutes.Message.GetMessages);
  return response;
}

export async function sendMessage(model: CreateMessage): Promise<AxiosResponse<ApiResponse<string>>> {
  const response = await axios.post(ApiRoutes.Message.SendMessage, model);
  return response;
}

export async function markAllMessagesAsRead(eocId: number): Promise<AxiosResponse<ApiResponse<boolean>>> {
  const response = await axios.put<ApiResponse<boolean>>(ApiRoutes.Message.MarkAllMessagesAsRead, { messageUserIdList: [], eocId });
  return response;
}

export async function getCareTeam(careTeamId: number): Promise<AxiosResponse<ApiResponse<User[]>>> {
  const params = {careTeamId: careTeamId};
  const response = await axios.get(ApiRoutes.Message.GetCareTeam, {params})
  return response;
}


export async function sendAIFeedback(helpful: boolean, eocId: number, conversationGuid: string): Promise<AxiosResponse<ApiResponse<boolean>>> {
  const response = await axios.post(ApiRoutes.Message.SendMAFeedback, {
    helpful,
    eocId,
    conversationGuid
  }, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  });
  return response;
}

export async function getEpubforMessageAssistant (url: string): Promise<AxiosResponse<ApiResponse<EducationAssetResponse>>> {
  const params = {url: url};
  const response = await axios.get(ApiRoutes.Message.GetEdItemFromURL, {params});
  return response;
}
